__turbopack_context__.v({
  "container": "formStatus-module-scss-module__dZOrYW__container",
  "green": "formStatus-module-scss-module__dZOrYW__green",
  "hide": "formStatus-module-scss-module__dZOrYW__hide",
  "orange": "formStatus-module-scss-module__dZOrYW__orange",
  "red": "formStatus-module-scss-module__dZOrYW__red",
  "show": "formStatus-module-scss-module__dZOrYW__show",
});
